import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { IconButton } from '@wordpress/components';
import { ENTER } from '@wordpress/keycodes';
/**
 * Internal dependencies
 */

import { URLInput } from '../';

var LinkControlSearchInput = function LinkControlSearchInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onSelect = _ref.onSelect,
      renderSuggestions = _ref.renderSuggestions,
      fetchSuggestions = _ref.fetchSuggestions,
      onReset = _ref.onReset,
      _onKeyDown = _ref.onKeyDown,
      onKeyPress = _ref.onKeyPress;

  var selectItemHandler = function selectItemHandler(selection, suggestion) {
    onChange(selection);

    if (suggestion) {
      onSelect(suggestion);
    }
  };

  var stopFormEventsPropagation = function stopFormEventsPropagation(event) {
    event.preventDefault();
    event.stopPropagation();
  };

  return createElement("form", {
    onSubmit: stopFormEventsPropagation
  }, createElement(URLInput, {
    className: "block-editor-link-control__search-input",
    value: value,
    onChange: selectItemHandler,
    onKeyDown: function onKeyDown(event) {
      if (event.keyCode === ENTER) {
        return;
      }

      _onKeyDown(event);
    },
    onKeyPress: onKeyPress,
    placeholder: __('Search or type url'),
    __experimentalRenderSuggestions: renderSuggestions,
    __experimentalFetchLinkSuggestions: fetchSuggestions,
    __experimentalHandleURLSuggestions: true
  }), createElement(IconButton, {
    disabled: !value.length,
    type: "reset",
    label: __('Reset'),
    icon: "no-alt",
    className: "block-editor-link-control__search-reset",
    onClick: onReset
  }));
};

export default LinkControlSearchInput;